import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../../shared/components/Icon';
import styles from './Arrow.scss';

const Arrow = ({ arrowClassName, onClick, iconName, variant, disabled, isDesktop }) => (
  <button
    className={classNames(styles[`${variant}Arrow${isDesktop ? 'OnDesktop' : ''}`], arrowClassName)}
    disabled={disabled}
    onClick={onClick}
  >
    <Icon
      className={styles.icon}
      name={iconName}
    />
  </button>
);

Arrow.propTypes = {
  arrowClassName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  iconName: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['previous', 'next']).isRequired,
  disabled: PropTypes.bool,
  isDesktop: PropTypes.bool,
};

export default Arrow;
